<script setup lang="ts">
import { useRoute } from 'vue-router'
import { betaOptIn } from '@/util/beta_opt_in'

const route = useRoute()
const wizardLink = { name: 'AssessmentWizard', query: { ...betaOptIn(route.query), ref: 'browse_assessments' } }
</script>

<template>
  <div class="mx-auto mb-4 mt-8 flex w-full max-w-[816px] flex-wrap items-center justify-between gap-5 rounded-xs border border-gray-400 p-4 text-left">
    <div class="min-w-[min(300px,100%)] max-w-[462px] flex-1">
      <p class="text-md font-medium leading-6 text-gray-900">Looking for a specific skill?</p>
      <p class="text-md leading-6 text-gray-700">Use the Assessment Wizard to find targeted resources at any skill or level.</p>
    </div>
    <div class="ai-border !rounded-xs !border flex-shrink-0">
      <router-link
        :to="wizardLink"
        class="inline-flex h-12 items-center whitespace-nowrap rounded-[3px] bg-white px-4 text-lg font-medium leading-6 text-[#004d72] hover:bg-[#e6e6e6] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-400"
      >
        Try the Assessment Wizard
      </router-link>
    </div>
  </div>
</template>
